import StoreVerification from './StoreVerification';

export default StoreVerification;
